import React, { FC } from 'react';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import breakpoints from '../../../../constants/breakpoints.constants';
import useEEActive from '../../../../hooks/useEEActive';
import { CardModel } from '../../../../models/card.model';
import { TCardProps } from '../../../../types/card.types';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import StoriesCardContent from './storiesCardContent';
import { TStoriesCardProps } from '../../types/blogNews.types';
import './styles.scss';
import { googleHomeCommunityClickEvent } from '../../../../utils/analytics';

const StoriesCard: FC<TCardProps & TStoriesCardProps> = (props) => {
  const model = new CardModel(props);
  const isEE = useEEActive();
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);

  return (
    <>
      {isEE || !model.link?.value?.href ? (
        <div
          className="stories-card"
          onClick={() => {
            googleHomeCommunityClickEvent(model?.title?.value, model.link?.value?.href, model.link?.value?.title);
          }}
        >
          <StoriesCardContent
            isEE={isEE}
            link={model.link}
            image={model.image}
            mobileImage={model.mobileImage}
            defaultCardImage={props?.defaultCardImage}
            title={model?.title}
            subtitle={model.subtitle}
            cardHeadingTag={props.cardHeadingTag}
          />
        </div>
      ) : (
        <RoutableSitecoreLink
          className="stories-card"
          field={model.link}
          target={targetLinkdsk(model?.link, isDesktop)}
          onClick={() => {
            googleHomeCommunityClickEvent(
              model?.title?.value,
              model.link?.value?.href,
              model.link?.value?.text || model.link?.value?.title
            );
          }}
        >
          <StoriesCardContent
            isEE={isEE}
            link={model.link}
            image={model.image}
            mobileImage={model.mobileImage}
            defaultCardImage={props?.defaultCardImage}
            title={model?.title}
            subtitle={model.subtitle}
            cardHeadingTag={props.cardHeadingTag}
          />
        </RoutableSitecoreLink>
      )}
    </>
  );
};

export default StoriesCard;
